var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 0.5C8.24844 0.5 8.4869 0.598772 8.66271 0.774588C8.83853 0.950403 8.9373 1.18886 8.9373 1.4375V7.0625H14.5623C14.8109 7.0625 15.0494 7.16127 15.2252 7.33709C15.401 7.5129 15.4998 7.75136 15.4998 8C15.4998 8.24864 15.401 8.4871 15.2252 8.66291C15.0494 8.83873 14.8109 8.9375 14.5623 8.9375H8.9373V14.5625C8.9373 14.8111 8.83853 15.0496 8.66271 15.2254C8.4869 15.4012 8.24844 15.5 7.9998 15.5C7.75116 15.5 7.5127 15.4012 7.33688 15.2254C7.16107 15.0496 7.0623 14.8111 7.0623 14.5625V8.9375H1.4373C1.18866 8.9375 0.950201 8.83873 0.774385 8.66291C0.59857 8.4871 0.499798 8.24864 0.499798 8C0.499798 7.75136 0.59857 7.5129 0.774385 7.33709C0.950201 7.16127 1.18866 7.0625 1.4373 7.0625H7.0623V1.4375C7.0623 1.18886 7.16107 0.950403 7.33688 0.774588C7.5127 0.598772 7.75116 0.5 7.9998 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusTable);
export default __webpack_public_path__ + "static/media/plus-table.560f9e5f085111f6b6d4ee46dcde0bcb.svg";
export { ForwardRef as ReactComponent };